import enMessages from '../../../messages/en.json';
import zhMessages from '../../../messages/zh.json';
import { MERCHANT_IMAGE_PAGES } from './merchant-images';
import { buildTemplateEntryHref } from '../routing/template-entry';
import { buildLocalizedSeoPath } from './site';
import type { SeoGuideArticle, SeoGuideLocale, SeoGuideSection } from './guides';

export const PRODUCT_PHOTOGRAPHY_GUIDE_PATH = '/guides/ai-product-photography-workflow';

/** 复用已验收的源图和四张原输出；教程文案以两份 locale 文件为准。 */
export function buildProductPhotographyGuide(locale: SeoGuideLocale): SeoGuideArticle {
  const copy = (locale === 'zh' ? zhMessages : enMessages).seoGuides.productPhotographyWorkflow;
  const config = MERCHANT_IMAGE_PAGES.ecommerce;
  const startHref = buildTemplateEntryHref(config.templateId, { locale, sourceLanding: PRODUCT_PHOTOGRAPHY_GUIDE_PATH });
  const sections: SeoGuideSection[] = copy.sections.map((section) => ({ ...section }));
  const caseSection = sections.find((section) => section.id === 'one-photo-case')!;
  caseSection.visuals = config.images.map((asset, index) => ({ ...asset, ...copy.visuals[index] }));
  caseSection.links = [{ label: copy.links.case, href: buildLocalizedSeoPath(config.path, locale) }];
  sections.find((section) => section.id === 'prepare-photo')!.links = [{ label: copy.links.template, href: startHref }];
  sections.find((section) => section.id === 'continue-cluster')!.links = [
    { label: copy.links.template, href: startHref },
    { label: copy.links.white, href: buildLocalizedSeoPath(MERCHANT_IMAGE_PAGES.whiteBackground.path, locale) },
    { label: copy.links.model, href: buildLocalizedSeoPath('/ai-fashion-model-generator', locale) },
    { label: copy.links.video, href: buildLocalizedSeoPath('/image-to-video-fashion', locale) },
  ];
  return {
    slug: 'ai-product-photography-workflow',
    path: PRODUCT_PHOTOGRAPHY_GUIDE_PATH,
    priority: 0.73,
    landingPath: config.path,
    title: copy.title,
    metadataTitle: copy.metadataTitle,
    description: copy.description,
    primaryKeyword: copy.primaryKeyword,
    searchIntent: copy.searchIntent,
    readingTime: copy.readingTime,
    heroImage: config.images[1].src,
    heroImageWidth: config.images[1].width,
    heroImageHeight: config.images[1].height,
    heroImageAlt: copy.heroImageAlt,
    images: config.images.map((image) => image.src),
    modifiedDate: '2026-09-14',
    startHref,
    takeawaysTitle: copy.takeawaysTitle,
    takeaways: copy.takeaways,
    sections,
    table: {
      title: copy.table.title,
      headers: [copy.table.headers[0], copy.table.headers[1], copy.table.headers[2]],
      rows: copy.table.rows.map((row) => [row[0], row[1], row[2]]),
    },
    checklistTitle: copy.checklistTitle,
    checklist: copy.checklist,
    sourceTitle: copy.sourceTitle,
    sources: [
      { label: copy.sourceLabels.shopify, href: 'https://help.shopify.com/en/manual/products/product-media' },
      { label: copy.sourceLabels.google, href: `https://support.google.com/merchants/answer/6324350?hl=${locale === 'zh' ? 'zh-Hans' : 'en'}` },
      { label: copy.sourceLabels.additional, href: `https://support.google.com/merchants/answer/6324370?hl=${locale === 'zh' ? 'zh-Hans' : 'en'}` },
    ],
    faq: copy.faq,
    ctaTitle: copy.ctaTitle,
    ctaBody: copy.ctaBody,
    ctaLabel: copy.ctaLabel,
  };
}
